export default __webpack_public_path__ + "static/media/Eye_Icon.7d0ebfaf.svg";